define('modules/chooseadaf',['backbone','text2!modules/daf/templates/dafchooser.html','wrap!lightbox_me'],
function(Backbone,modalTemplate) {
	var masechtot = [];
	var availableDappim = [];
	var availableMasechtot = [];

	var ChooseADaf = Backbone.View.extend({
		events: {
			'click': function() {
				new ChooseADafModal({
					allMasechtot:this.options.allMasechtot,
					destination:this.options.destination
				}).$el.lightbox_me({
					overlayCSS:	{background: 'black', opacity: .8},
					centered: true,
					closeClick: false,
					closeSelector:	".close",
					zIndex: 9000
				});
			}
		}
	});

	function engNumber2Hebrew($num) {
		$hundreds = ['','ק'];
		$tens = ['','י','כ','ל','מ','נ','ס','ע','פ','צ'];
		$ones = ['','א','ב','ג','ד','ה','ו','ז','ח','ט'];

		$hundred = $hundreds[Math.floor($num/100)];
		$ten = $tens[Math.floor(($num%100)/10)];
		$one = $ones[$num%10];

		if ($ten == 'י' && $one == 'ה') {
			$ten = 'ט';
			$one = 'ו';
		}

		if ($ten == 'י' && $one == 'ו') {
			$ten = 'ט';
			$one = 'ז';
		}
		
		return $hundred+$ten+$one;
	}

	var ChooseADafModal = Backbone.View.extend({
		_ensureElement: function() {
			this.setElement($(modalTemplate));
		},
		events: {
			'change #masechtaSelector': function(e) {
				var val = $(e.currentTarget).val();
				if (!$(e.currentTarget).val()) {
					this.$("#dafList").empty();
					return;	
				}

				this.$("#dafList").empty();

				for(var i = 2; i <= masechtot[val].dapim; i++) {
					var destination = this.options.destination ? this.options.destination(val+'_'+i) : '/daf/'+val+'_'+i;

					this.$("#dafList").append($('<li><a href="'+destination+'">'+masechtot[val].name+' '+engNumber2Hebrew(i)+'</a></li>').addClass(function(){
						return availableDappim.indexOf((val[0].toUpperCase()+val.slice(1))+i) == -1 ? 'hide':'';
					}));
				}
			}
		},
		initialize: function() {
			$.when($.getJSON('/api/masechtas'),$.getJSON('/api/availableMasechtas')).then(function(m,a) {
				this.$("select").show();
				this.$("#loading").remove();
				masechtot = m[0];

				if (this.options.allMasechtot) {
					for(var i = 0; i < _(masechtot).values().length; i++) {
						for(var j = 2; j <= _(masechtot).values()[i].dapim; j++) {
							var daf = _(masechtot).values()[i].name.toLowerCase().replace(' ','_')+j;

							availableDappim.push(daf[0].toUpperCase()+daf.slice(1));
						}
					}
				}
				else {
					availableDappim = a[0]; 
				}

				availableDappim = _(availableDappim).sortBy(function(daf) {
					return String.fromCharCode(parseInt(daf.replace(/[a-zA-Z]+/,'')+65));
				});

				availableMasechtot = _(availableDappim)
					.groupBy(function(masechta) {
						return masechta.replace(/\d+/,'').toLowerCase();
					});
			

				for(var masechta in masechtot) {
					if (availableMasechtot[masechta]) {
						this.$("#masechtaSelector").append('<option value="'+masechta+'">'+masechtot[masechta].name);
					}
				}	
			}.bind(this));
		}
	});

	return ChooseADaf;
});

